import { call, put, takeLatest } from 'redux-saga/effects';
import { StatusCodes } from 'http-status-codes';
import invokeApi from '../network';
import networkConfig from '../network/config';
import { SUBMIT_FEEDBACK } from '../constants';
import { submitFeedbackError, submitFeedbackSuccess } from '../redux/Actions/FeedbackAction';
import { setErrorCode } from '../redux/Actions/ErrorAction';
export function* submitFeedbackCall(request) {
    try {
        const { tenantId = '', payload = {} } = request.request;
        const headers = {
            'x-tenant-id': tenantId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.submitFeedback, null, headers, payload);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (status === StatusCodes.OK || status === StatusCodes.CREATED || status === StatusCodes.ACCEPTED) {
            yield put(submitFeedbackSuccess(response, status));
        }
        else {
            yield put(submitFeedbackError());
        }
    }
    catch (error) {
        yield put(submitFeedbackError(error));
    }
}
export function* submitFeedbackSaga() {
    yield takeLatest(SUBMIT_FEEDBACK, submitFeedbackCall);
}
